import React from 'react';
import { DownloadIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
const perks = [{
  icon: ZapIcon,
  label: 'Acceso digital inmediato'
}, {
  icon: DownloadIcon,
  label: 'Descarga directa'
}, {
  icon: ShieldCheckIcon,
  label: 'Sin complicaciones'
}];
export function FinalCta() {
  return <section id="comprar" aria-labelledby="cta-titulo" className="relative w-full overflow-hidden bg-ink text-cream" data-id="element-32" data-mp="1jd52dresm85g">
      <div className="blueprint-grid-dark absolute inset-0" aria-hidden="true" data-id="element-33" data-mp="1ed0lw1dvxdf8" />
      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 sm:py-28" data-id="element-34" data-mp="1t3g5xcukefbt">
        <Reveal data-id="element-35" data-mp="1o43hino1p074">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-clay" data-id="element-36" data-mp="1o3lixkdwu9w1">
            Llamado a la acción
          </p>
          <h2 id="cta-titulo" className="mt-5 font-display text-3xl font-bold leading-[1.08] sm:text-[3rem]" data-id="element-37" data-mp="223w6oejxb8cz">
            Dejá de postergar esos arreglos simples
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-cream/75" data-id="element-38" data-mp="n7p2x52vyvfk">
            Aprendé lo básico, ganá seguridad y empezá a transformar tu casa con
            tus propias manos.
          </p>

          <p className="mt-8 font-display text-5xl font-bold leading-none sm:text-6xl" data-id="element-39" data-mp="122vcg216xcdn">
            $28.990
          </p>
          <p className="mt-2 text-sm font-medium uppercase tracking-[0.18em] text-cream/60" data-id="element-40" data-mp="16506h1vjwb0t">
            Único pago · 6 tomos + 5 bonos
          </p>

          <div className="mt-8 flex justify-center" data-id="element-41" data-mp="1b1qm5o3g14lp">
            <CtaButton size="lg" data-id="element-42" data-mp="1fu04ahybh0df">
              Quiero acceso inmediato ahora
            </CtaButton>
          </div>

          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-43" data-mp="1ks1nr3znn1pf">
            {perks.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm font-medium text-cream/70" data-id="element-44" data-mp="1pqmrvei125j5">
                <Icon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-45" data-mp="3qvqgtne74oi7" />
                {label}
              </li>)}
          </ul>

          <p className="mt-12 font-display text-2xl font-bold sm:text-3xl" data-id="element-46" data-mp="3ltrduemdbtls">
            Tu casa puede mejorar. Y lo vas a hacer vos.
          </p>
        </Reveal>
      </div>
    </section>;
}